import HomeV2 from './HomeV2';
export default HomeV2; 